import { render, staticRenderFns } from "./InsuranceForm.vue?vue&type=template&id=739f46ff"
import script from "./InsuranceForm.vue?vue&type=script&lang=ts"
export * from "./InsuranceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports